"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IllegalArgumentException = void 0;
const exception_1 = require("./exception");
/**
 * Indicates that a function has been provided an illegal or inappropriate argument.
 */
class IllegalArgumentException extends exception_1.Exception {
    constructor(message) {
        super(message);
        this[Symbol.toStringTag] = 'IllegalArgumentException';
        this.name = 'IllegalArgumentException';
    }
}
exports.IllegalArgumentException = IllegalArgumentException;
//# sourceMappingURL=illegal-argument-exception.js.map